<template>
  <div class="select-scale-container">
    <label class="control-label">Tipo de escala</label>
    <Select v-model="scale" :options="scaleList" :disabled="disabled" />
  </div>
</template>

<script>
import Select from '@/components/common/Select'

export default {
  components: {
    Select
  },
  props: {
    value: [String],
    disabled: {
      type: Boolean,
      default: () => { return false }
    }
  },
  data() {
    return {
      scaleList: [
        { label: 'Administrativo', value: 'adm' },
        { label: 'Plantão Impar', value: 'impar' },
        { label: 'Plantão Par', value: 'par' },
        { label: 'Personalizado', value: '*' }
      ],
      scale: ''
    }
  },
  watch: {
    scale(value) {
      this.update(value)
    },
    value(value) {
      this.scale = value
    }
  },
  methods: {
    update(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped>
.select-scale-container {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
  font-family: BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/SelectScaleType.vue